import { useEffect, useReducer, useRef } from 'react';

function promiseReducer(state, action) {
  switch (action.type) {
    case 'pending':
      return {
        pending: true,
        result: null,
        error: null,
        refresh: null
      };

    case 'fulfilled':
      return {
        pending: false,
        result: action.payload,
        refresh: action.refresh
      };

    default:
      return {
        pending: false,
        error: action.payload,
        refresh: action.refresh
      };
  }
}

export function usePromise(promiseFn, memoizeOn = [], runPromise = true) {
  const initialState = {
    result: null,
    error: null,
    pending: true,
    refresh: null
  };
  const [state, dispatch] = useReducer(promiseReducer, initialState);

  const promiseExecuter = () => {
    dispatch({
      type: 'pending'
    });
    promiseFn().then(result => dispatch({
      type: 'fulfilled',
      payload: result,
      refresh: promiseExecuter
    })).catch(error => dispatch({
      type: 'error',
      payload: error,
      refresh: promiseExecuter
    }));
  };

  useEffect(() => {
    if (runPromise) {
      promiseExecuter();
    }
  }, memoizeOn);
  return state;
}
/**
 * In functional components, it isn't possible to get the previous
 * value of a state / prop directly (something that was possible
 * using lifecycle methods of class components). This hook provides
 * a lagging version of the value passed to it.
 */

export function usePrevious(value) {
  // $FlowFixMe Flow doesn't like empty args to `useRef` when using generics
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}